<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Facts</span>
        <span slot="title">Facts</span>
      </AffixHeader>

      <template v-if="$can('create', 'facts')">
        <i-button type="primary" @click="$router.push('/facts/new')">
          <FFIcon type="plus" />New Master Fact
        </i-button>
        <br />
        <br />
      </template>

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="70" label-position="right">
          <Row>
            <i-col span="12">
              <i-form-item label="Name" style="margin-right:6px;">
                <i-input v-model="form.name"></i-input>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Year">
                <i-select v-model="form.year" filterable multiple>
                  <i-option v-for="year in years" :key="year" :value="year">{{ year }}</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Country" style="margin-right:6px;">
                <CountrySelect v-model="form.country" filterable multiple></CountrySelect>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Region" style="margin-right:6px;">
                <i-select v-model="form.region" filterable multiple>
                  <i-option value="Latin America and the Caribbean">Latin America and the Caribbean</i-option>
                  <i-option value="North America">North America</i-option>
                  <i-option value="South Asia">South Asia</i-option>
                  <i-option value="Sub-Saharan Africa">Sub-Saharan Africa</i-option>
                  <i-option value="Middle East and North Africa">Middle East and North Africa</i-option>
                  <i-option value="East Asia and Pacific">East Asia and Pacific</i-option>
                  <i-option value="Europe and Central Asia">Europe and Central Asia</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Cause" style="margin-right:6px;">
                <i-select v-model="form.displacement_type" filterable multiple>
                  <i-option value="Conflict">Conflict</i-option>
                  <i-option value="Disaster">Disaster</i-option>
                  <i-option value="Development">Development</i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Type">
                <FactsTypeSelect v-model="form.type" filterable multiple />
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Class" style="margin-right:6px;">
                <i-select v-model="form.class" filterable multiple>
                  <i-option value="Fact">Fact</i-option>
                  <i-option value="Master">Master</i-option>
                  <i-option value="Sub">Sub</i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="MF Role">
                <i-select v-model="form.parent_role" filterable multiple>
                  <i-option v-for="role in roles" v-bind:key="role" :value="role">{{ role }}</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <i-form-item label="User" style="margin-right:6px;">
                <UserSelect v-model="form.user" filterable></UserSelect>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Groups">
                <GroupSelect v-model="form.groups" />
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Event" style="margin-right:6px;">
                <EventSelect v-model="form.event_id" filterable multiple></EventSelect>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Event Role">
                <i-select v-model="form.event_role" filterable multiple>
                  <i-option v-for="role in roles" v-bind:key="role" :value="role">{{ role }}</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Hazard" style="margin-right:6px;">
                <i-select v-model="form.hazard_subtype" filterable>
                  <i-option value="Coastal flood">Coastal flood</i-option>
                  <i-option value="Dam release flood">Dam release flood</i-option>
                  <i-option value="Drought">Drought</i-option>
                  <i-option value="Dry mass movement">Dry mass movement</i-option>
                  <i-option value="Earthquake">Earthquake</i-option>
                  <i-option value="Earthquake, Ground Shaking">Earthquake, Ground Shaking</i-option>
                  <i-option value="Earthquake, Tsunami">Earthquake, Tsunami</i-option>
                  <i-option
                    value="Exterme temp, Severe winter conditions"
                  >Exterme temp, Severe winter conditions</i-option>
                  <i-option value="Extreme temperature">Extreme temperature</i-option>
                  <i-option
                    value="Extreme temp, Extreme Heat / Heat Wave"
                  >Extreme temp, Extreme Heat / Heat Wave</i-option>
                  <i-option
                    value="Extreme temp, Winter Conditions / Cold Wave"
                  >Extreme temp, Winter Conditions / Cold Wave</i-option>
                  <i-option value="Flash flood">Flash flood</i-option>
                  <i-option value="Flood">Flood</i-option>
                  <i-option
                    value="Glacial Lake Outburst Floods (GLOF)"
                  >Glacial Lake Outburst Floods (GLOF)</i-option>
                  <i-option value="Hailstorm">Hailstorm</i-option>
                  <i-option value="Ice jam flood">Ice jam flood</i-option>
                  <i-option value="Landslide, Avalanche">Landslide, Avalanche</i-option>
                  <i-option value="Mass movement, Landslide">Mass movement, Landslide</i-option>
                  <i-option value="Mass movement, Rock fall">Mass movement, Rock fall</i-option>
                  <i-option
                    value="Mass movement, Sudden subsidence/sinkhole"
                  >Mass movement, Sudden subsidence/sinkhole</i-option>
                  <i-option value="Nor'wester">Nor'wester</i-option>
                  <i-option value="Other">Other</i-option>
                  <i-option value="Riverine flood">Riverine flood</i-option>
                  <i-option value="Storm">Storm</i-option>
                  <i-option value="Storm, Convective">Storm, Convective</i-option>
                  <i-option value="Storm, Extra-tropical">Storm, Extra-tropical</i-option>
                  <i-option value="Storm, Storm surge">Storm, Storm surge</i-option>
                  <i-option value="Storm, Tropical">Storm, Tropical</i-option>
                  <i-option value="Storm, Tropical, Cyclone">Storm, Tropical, Cyclone</i-option>
                  <i-option value="Storm, Tropical, Hurricane">Storm, Tropical, Hurricane</i-option>
                  <i-option value="Storm, Tropical, Typhoon">Storm, Tropical, Typhoon</i-option>
                  <i-option value="Thunderstorm">Thunderstorm</i-option>
                  <i-option value="Tornado">Tornado</i-option>
                  <i-option value="Volcanic activity, Ash fall">Volcanic activity, Ash fall</i-option>
                  <i-option value="Volcanic activity, Lahar">Volcanic activity, Lahar</i-option>
                  <i-option value="Volcanic activity, Lava flow">Volcanic activity, Lava flow</i-option>
                  <i-option
                    value="Volcanic activity, Pyroclastic flow"
                  >Volcanic activity, Pyroclastic flow</i-option>
                  <i-option value="Volcanic activity, Toxic gases">Volcanic activity, Toxic gases</i-option>
                  <i-option value="Volcanic eruption">Volcanic eruption</i-option>
                  <i-option value="Wave action, Rogue wave">Wave action, Rogue wave</i-option>
                  <i-option value="Wave action, Seiche">Wave action, Seiche</i-option>
                  <i-option value="Wet mass movement">Wet mass movement</i-option>
                  <i-option value="Wildfire">Wildfire</i-option>
                  <i-option value="Wildfire - Firenado">Wildfire - Firenado</i-option>
                  <i-option value="Wildfire - Forest">Wildfire - Forest</i-option>
                  <i-option value="Wildfire - Land fire">Wildfire - Land fire</i-option>
                  <i-option value="Winter storm">Winter storm</i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="4">
              <i-form-item label="Date type" style="margin-right:6px;">
                <i-select v-model="form.date_range_type" clearable>
                  <i-option value="stock_date">Stock Date</i-option>
                  <i-option value="start_date">Start Date</i-option>
                  <i-option value="end_date">End Date</i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="8">
              <i-form-item label="Date Range" class="wider-label">
                <DatePicker
                  v-model="form.date_range"
                  format="yyyy-MM-dd"
                  type="daterange"
                  style="width:100%;"
                ></DatePicker>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Status" style="margin-right:6px;">
                <i-select v-model="form.status" filterable multiple>
                  <i-option value="Under Review">Under Review</i-option>
                  <i-option value="Review Completed">Review Completed</i-option>
                  <i-option value="Signed Off">Signed Off</i-option>
                  <i-option value="Locked Down">Locked Down</i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Themes">
                <ThemeSelect v-model="form.themes" />
              </i-form-item>
            </i-col>
          </Row>

          <Row type="flex" justify="end" style="margin:12px 0;">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>

      <br />
      <FactsTable :conditions="conditions" v-on:updateFactCount="n => (factCount = n)"></FactsTable>
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import FactsTable from "@/facts/table";
import CountrySelect from "@/components/country_select";
import UserSelect from "@/components/user_select";
import EventSelect from "@/components/event_select";
import GroupSelect from "@/components/GroupSelect";
import ThemeSelect from "@/components/ThemeSelect";
import FactsTypeSelect from "@/components/fact_type_select.vue";
import { mapGetters, mapMutations } from "vuex";
import { getTsQueryValue } from "@/utils/common";

export default {
  components: {
    FactsTable,
    CountrySelect,
    UserSelect,
    EventSelect,
    GroupSelect,
    ThemeSelect,
    FactsTypeSelect,
  },
  data() {
    return {
      form: {
        name: "",
        serial_no: "",
        year: [],
        date_range: "",
        date_range_type: "",
        displacement_type: [],
        type: [],
        class: [],
        groups: [],
        themes: [],
        country: [],
        region: [],
        event_id: [],
        status: [],
        user: "",
        parent_role: [],
        event_role: [],
        hazard_subtype: "",
      },
      roles: [
        "Triangulation",
        "Recommended figure",
        "Partial figure (Added)",
        "Partial figure (Subtracted)",
      ],
      conditions: {},
      factCount: 0,
    };
  },
  created() {
    if (this.searches["facts"]) {
      this.form = { ...this.form, ...this.searches["facts"] };
      this.search();
    }
  },
  computed: {
    ...mapGetters(["searches"]),
    years() {
      const currYear = new Date().getFullYear();
      return _.range(currYear, 1950, -1);
    },
  },
  methods: {
    ...mapMutations(["setSearch"]),
    reset() {
      this.form = {
        name: "",
        serial_no: "",
        year: [],
        date_range: "",
        displacement_type: [],
        type: [],
        class: [],
        groups: [],
        themes: [],
        country: [],
        region: [],
        event_id: [],
        status: [],
        user: "",
        hazard_subtype: "",
      };
      this.conditions = {};
      this.setSearch({ type: "facts", data: null });
    },

    search() {
      let conditions = {};

      // Name
      if (this.form.name !== "") {
        conditions["name"] = getTsQueryValue(this.form.name)
      }

      // Serial No.
      if (this.form.serial_no !== "") {
        conditions["serial_no"] = "eq." + this.form.serial_no;
      }

      // Year
      if (this.form.year.length > 0) {
        conditions["year"] = "in.(" + this.form.year.toString() + ")";
      }

      // Date Range
      if (!!this.form.date_range_type && this.form.date_range.length > 1) {
        const _start = moment(this.form.date_range[0]);
        const _end = moment(this.form.date_range[1]);
        if (_start.isValid() && _end.isValid()) {
          const start = _start.format("YYYY-MM-DD");
          const end = _end.format("YYYY-MM-DD");
          const type = this.form.date_range_type;
          conditions["and"] = `(${type}.gte.'${start}',${type}.lte.'${end}')`;
        }
      }

      // Displacement Type
      if (this.form.displacement_type.length > 0) {
        conditions["displacement_type"] =
          "in.(" + this.form.displacement_type.toString() + ")";
      }

      // Fact Type
      if (this.form.type.length > 0) {
        conditions["type"] = "in.(" + '"' + this.form.type.join('","') + '")';
      }

      // Fact class
      if (this.form.class.length > 0) {
        conditions["class"] = "in.(" + '"' + this.form.class.join('","') + '")';
      }

      // Groups
      if (this.form.groups.length > 0) {
        conditions["groups"] =
          "cs." + '{"' + this.form.groups.join('","') + '"}';
      }

      // Themes
      if (this.form.themes.length > 0) {
        conditions["themes"] =
          "cs." + '{"' + this.form.themes.join('","') + '"}';
      }

      // Country
      if (this.form.country.length > 0) {
        conditions["iso3"] =
          "in.(" + '"' + this.form.country.join('","') + '")';
      }

      // Region
      if (this.form.region.length > 0) {
        conditions["region"] =
          "in.(" + '"' + this.form.region.join('","') + '")';
      }

      // User
      if (this.form.user && this.form.user !== "") {
        conditions["created_by"] = "eq." + this.form.user;
      }

      // Event
      if (this.form.event_id.length > 0) {
        conditions["event_id"] = "in.(" + this.form.event_id.toString() + ")";
      }

      // Hazard Subtype
      if (this.form.hazard_subtype.length > 0) {
        conditions["hazard_subtype"] = "eq." + this.form.hazard_subtype;
      }

      // Status
      if (this.form.status && this.form.status.length > 0) {
        conditions["status"] = "in.(" + this.form.status.toString() + ")";
      }

      // Parent Role
      if (this.form.parent_role && this.form.parent_role.length > 0) {
        conditions["parent_role"] =
          "in.(" + this.form.parent_role.toString() + ")";
      }

      // Event Role
      if (this.form.event_role && this.form.event_role.length > 0) {
        conditions["event_role"] =
          "in.(" + this.form.event_role.toString() + ")";
      }

      this.conditions = conditions;
      this.setSearch({ type: "facts", data: this.form });
    },
  },
};
</script>

<style lang="css">
.wider-label label.ivu-form-item-label {
  width: 90px !important;
}

.wider-label div.ivu-form-item-content {
  margin-left: 90px !important;
}
</style>
